import { bindable } from "aurelia-typed-observable-plugin";

export class LoadingOverlay {
    @bindable.boolean
    public visible: boolean = false;
}
